import { CheckIcon, CopyIcon } from '@radix-ui/react-icons'
import { Button, IconButton } from '@radix-ui/themes'
import { useEffect, useState, type ReactNode } from 'react'
import copyToClipboard from 'copy-to-clipboard'

const COPIED_FEEDBACK_MS = 2000

export interface CopyButtonProps {
  value: string
  label: string
  children?: ReactNode
  iconOnly?: boolean
  disabled?: boolean
}

export const CopyButton = ({ value, label, children, iconOnly = false, disabled = false }: CopyButtonProps) => {
  const [copied, setCopied] = useState(false)

  useEffect(() => {
    if (!copied) return
    const timer = setTimeout(() => setCopied(false), COPIED_FEEDBACK_MS)
    return () => clearTimeout(timer)
  }, [copied])

  const copy = () => {
    copyToClipboard(value)
    setCopied(true)
  }

  const icon = copied ? <CheckIcon /> : <CopyIcon />

  if (iconOnly) {
    return (
      <IconButton
        type="button"
        size="1"
        variant="ghost"
        disabled={disabled}
        onClick={copy}
        title={label}
        aria-label={label}
      >
        {icon}
      </IconButton>
    )
  }

  return (
    <Button
      type="button"
      size="1"
      variant="soft"
      color="gray"
      disabled={disabled}
      onClick={copy}
      title={label}
      aria-label={label}
    >
      {icon}
      {children}
    </Button>
  )
}
